
import React from 'react';
import ModalFrame from '../../ModalFrame';
import Export from './Export';

class ModalExportController extends React.Component {
  constructor(props) {
    super(props);
    this.hideModal = this.hideModal.bind(this);

  }


  hideModal() {
    const {setModalInfo} = this.props;
    setModalInfo({});
  }

  render() {
    const {modalInfo, confirmHandler} = this.props;
    return (
      <div className="example-modal">
        {modalInfo.name === 'exportTranscript' ?
          <ModalFrame
            title="SHARE THIS TRANSCRIPT"
            desktopWidth="50%"
            headerCloseButtonHandler={this.hideModal}
            hasHeader={true}>
            <Export
              modalInfo={modalInfo}
              hideModal={this.hideModal}
              confirmHandler={confirmHandler}
            />
          </ModalFrame> : null}
      </div>
    )
  }
}

export default ModalExportController;
